import { makeAutoObservable, reaction, runInAction } from "mobx";
import agent from "../api/agent";
import { IGuestPinFormValues, IGuestScreenValues, IScreenInfo } from "../models/guest";
import { RootStore } from "./rootStore";
import cmsThemes from "../models/theme";
import {RedirectGuestScreen, getQRDataUrl } from "../helpers/urlHelper";

export default class GuestStore {
  rootStore: RootStore;
  constructor(rootStore: RootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);

    reaction(
      () => this.presentationLoaded,
      (presentationLoaded) => {
        if(presentationLoaded){
          this.getThemeGuest(this.guestTheme);
        } 
      }
    );
  }

  getThemeGuest= (guestTheme: string) => {
    this.rootStore.commonStore.theme = cmsThemes.get("template")
    this.rootStore.commonStore.loadThemeTenant(guestTheme);
  }

  presentationLoaded: boolean = false;
  pinValidated: boolean = false;
  presentationName: string = "";
  tempToken: string = "";
  guestUsername: string = "";
  guestTheme: string ="";
  guestScreen : IScreenInfo | null= null
  isGlobalGuestFullyEnabled : boolean = false;
  


  get showPresentationPage() {
    const { currentBrowsePageContent } = this.rootStore.commonStore;
    const hasContent = currentBrowsePageContent ? true : false;
    return this.presentationLoaded && hasContent ;
  }

  confirmOpenDocument = () => {
    // const { setToken } = this.rootStore.commonStore;
    // setToken(this.tempToken);
    this.loadPresentation();
  };

  cancelOpenDocument = () => {
    this.pinValidated = false;
  }

  loadPresentation = async (onlyGuest : boolean = false) => {
    const { company, setGuestBrowsePageContent } = this.rootStore.commonStore;
    if (company) {
      let pin = "";
      if(this.isGlobalGuestFullyEnabled){
        let localStoragePresentationString = localStorage.getItem('Presentation_Pin') ?? ""; //per il globalguest
        pin = localStoragePresentationString.split("_")[1];
      }
      const dto = await agent.Guest.presentation(company.id, pin);
      runInAction(() => {
        if(onlyGuest){
          this.guestTheme= dto.guestTheme;
          this.getThemeGuest(this.guestTheme);
        }else{
          if (dto && dto.files !== null) {
            this.presentationLoaded = true;
            this.isGlobalGuestFullyEnabled = company.isGlobalGuestFullyEnabled;
            this.guestUsername = dto.guestUsername;
            setGuestBrowsePageContent(dto);
          }
          
          this.guestTheme= dto.guestTheme;
          this.getThemeGuest(this.guestTheme);
      }
      });
      return dto;
    }
  };





  loadGuestByCodeZone = async (zoneCode : string) => {
    
const { company} = this.rootStore.commonStore;
 if (company) {
      const dto = await agent.Guest.presentationByCode(  company.id, zoneCode);
      runInAction(() => {
          this.presentationLoaded= dto;
      });
    
      return dto;
    }
  };


getInfoPresentation = async (presentationId : number, pin: string) => {
 const dto = await agent.Guest.presentationInfo(presentationId, pin);
 if(dto){
  
  runInAction(() => {
       if(dto.presentationId>0){
      this.pinValidated = true;
      this.presentationName = dto.presentationName;
       }else{
           // Pin non più valido
        this.pinValidated = false;
        this.presentationName = "";
        localStorage.setItem('Presentation_Pin', "")
        // resettare il cookie
       }
    
      // this.tempToken = dto.token;
      // this.rootStore.commonStore.theme = cmsThemes.get("template")
      // this.rootStore.commonStore.loadThemeTenant("default");
  });
  
 }
return dto; 
}


  submitDocumentPin = async (formValues: IGuestPinFormValues, presentationId? : number , skipError : boolean = false, openPresentation: boolean = true) => {
    const { company } = this.rootStore.commonStore;
    console.log("submitDocumentPin")
    try {
      if (company) {
        const dto = await agent.Guest.authPresentationPin(
          company.id,
          formValues.pin,
          formValues.zone,
          presentationId
        );
        if (dto) {
          runInAction(() => {
            if(openPresentation === true){
              this.pinValidated = true;
              this.presentationName = dto.presentationName;
            }
              // this.tempToken = dto.token;
              // this.rootStore.commonStore.theme = cmsThemes.get("template")
              // this.rootStore.commonStore.loadThemeTenant("default");
          });
          return dto;
        }
        return undefined;
      } 
      return undefined;      
    } catch (error) {
      if(skipError) return undefined;
      console.log(error);
      throw error;
    }
  };

  // logout = async (additionalUrl? : string) => {
  //   const result= await agent.Guest.logout().then((dto) => {
  //     if(dto){
  //       this.presentationLoaded = false;
  //       this.pinValidated = false;
  //       this.rootStore.playerStore.setActiveTab("1");
  //   ;
  //   }
  //   });
  //  return result;
  // }

  logout = async (additionalUrl? : string) => {
    const result= await agent.Guest.logout();
   if(result){
    
    this.presentationLoaded = false;
    this.pinValidated = false;
    this.rootStore.playerStore.setActiveTab("1");
  }
    return result;  
  }
 
  


  redirectGuestScreen = async (additionalUrl? : string) => {
    RedirectGuestScreen(additionalUrl);
  }


  GetScreenByCode = async (values : IGuestScreenValues) => {
    const { company} = this.rootStore.commonStore;
     if (company) {
          const dto = await agent.Guest.getScreenByCode(  company.id, values.code);
          runInAction(() => {
              this.guestScreen= dto
          });
        if(dto){
          localStorage.setItem('launcherGuestScreen', "1")
        }
          return dto;
        }
      };
     
  RedirectGuest = async (screen : IScreenInfo) => {
    let url= getQRDataUrl(screen.qrDataType , screen.url , screen.code , screen.screenTypeId , screen.fingerPrint);
    window.location.href = url
    }

}
